import $ from 'jquery';
import yt from '../globals/youtube';

export default class HomeVideo {
  constructor(section) {
    this.$body = $(document.body);
    this.$el = $(section.el);

    this.$videoOpen = this.$el.find('[data-home-video-play]');
    this.$videoClose = this.$el.find('[data-home-video-close]');
    this.$videoIframe = this.$el.find('.home-video-iframe');

    this.events = [
      this.$videoOpen.on('click.home-video', event => {
        this.openVideo();
      }),

      this.$videoClose.on('click.home-video', (event) => {
        event.preventDefault();
        this.closeVideo();
      }),
    ];
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.home-video'));
  }

  openVideo() {
    this.$videoIframe.attr('src', this.$videoIframe.attr('src').replace('autoplay=0', 'autoplay=1'));
    this.$el.find('.home-video-cover-icon').toggleClass('hide');

    this.$videoIframe.one('load', () => {
      this.$el.find('.home-video-cover-icon').toggleClass('hide');
      this.$el.addClass('home-video-active');

      // Vertically centre section within viewport
      this.$body.animate({
        scrollTop: this.$el.offset().top - ($(window).height() - this.$el.outerHeight(true)) / 2
      }, 800);
    });

    if (this.$videoIframe.length && this.$videoIframe.attr('src').match(/youtube/)) {
      if (this.player) {
        this.player.playVideo();
      } else {
        yt(() => this.initYouTube());
      }
    }
  }

  closeVideo() {
    this.$el.removeClass('home-video-active');

    if (this.player) {
      this.player.stopVideo();
    }
  }

  initYouTube() {
    const videoId = this.$videoIframe.attr('data-video-id');

    this.player = new YT.Player(`v${videoId}`, {
      events: {
        onReady: () => this.player.playVideo(),
      },
    });
  }
}
